import { Component } from '@angular/core';
@Component({ standalone: false,
    selector: 'dux-app-default-header',
    styles:[`
    :host{width:100%}
    /*.ag-header-irb-col-info{width:14px;height:14px}*/
    `],
    template: `
    <div class="ag-cell-label-container" [ngClass]="sortStyleClassName">
      @if (params.irbColInfo) {
        <div class="ag-header-irb-col-info">
          <div class="infoIcon" calltoaction [calltoactionTemplate]="irbColInfoTemplateRef" [calltoactionPosition]="params.irbColPosition ? params.irbColPosition : 'bottom'"></div>
        </div>
      }
    
      <div ref="eLabel" class="ag-header-cell-label" role="presentation" unselectable="on" (click)="onSortRequested($event)">
        @if (params.irbSimpleHtmlHeader) {
          <div class="normal-white-space ag-header-cell-text" ref="eText" role="columnheader" [innerHTML]="params.irbSimpleHtmlHeader"  calltoaction [calltoactionTemplate]="irbSimpleHtmlHeaderTemplateRef" [calltoactionPosition]="params.irbColPosition ? params.irbColPosition : 'bottom'" [calltoactionUsesHover]="true"></div>
        }
        @if (!params.irbSimpleHtmlHeader) {
          @if (params.tooltipDisplayName) {
            <span ref="eText" class="ag-header-cell-text" role="columnheader" unselectable="on" ><span tooltip [tooltipTitle]="params.tooltipDisplayName" [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0' [innerHTML]="params.displayName"></span></span>
          }
          @if (!params.tooltipDisplayName) {
            <span ref="eText" class="ag-header-cell-text" role="columnheader" unselectable="on" ><span tooltip [tooltipTitle]="params.displayName" [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0' [innerHTML]="params.displayName"></span></span>
          }
        }
        <span ref="eSortOrder" class="ag-header-icon ag-header-label-icon ag-sort-order ag-hidden" aria-hidden="true">1</span>
        <span ref="eSortAsc" class="ag-header-icon ag-header-label-icon ag-sort-ascending-icon" [ngClass]="currentSortOrder=='asc'?'':'ag-hidden'" aria-hidden="true">
          <span class="ag-icon ag-icon-asc" unselectable="on"></span>
        </span>
        <span ref="eSortDesc" class="ag-header-icon ag-header-label-icon ag-sort-descending-icon" [ngClass]="currentSortOrder=='desc'?'':'ag-hidden'" aria-hidden="true">
          <span class="ag-icon ag-icon-desc" unselectable="on"></span>
        </span>
        <span ref="eSortNone" class="ag-header-icon ag-header-label-icon ag-sort-none-icon ag-hidden" aria-hidden="true">
          <span class="ag-icon ag-icon-none" unselectable="on"></span>
        </span>
    
      </div>
      <ng-template #irbColInfoTemplateRef ><div [innerHTML]="params.irbColInfo"></div></ng-template>
      <ng-template #irbSimpleHtmlHeaderTemplateRef ><div [innerHTML]="params.irbSimpleHtmlHeaderToolTip"></div></ng-template>
      <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
    </div>
    `
})
export class IrbDefaultHeaderComponent {
    params: any;
    sortStyleClassName: string;
    nextSortOrder:string;
    currentSortOrder:string;
    irbColInfoTemplateRef:string;
    agInit(params: any): void {
        this.irbColInfoTemplateRef = 'tempRef' + params.column.colId;
        this.params = params;
        params.column.addEventListener(
            'sortChanged',
            this.setSortStyleClassName.bind(this)
          );
          this.nextSortOrder = (this.params.column.sort)?this.params.column.sort: 'asc';
    }

    refresh(): boolean {
        return true;
    }

    onSortRequested(event:any) {
        if(this.params.enableSorting) {
            this.params.setSort(this.nextSortOrder, event.shiftKey);
            this.setSortStyleClassName();
        }
    }
    setSortStyleClassName(){
        if(this.params.enableSorting){
            if (this.params.column.isSortAscending()) {
                this.sortStyleClassName='ag-header-cell-sorted-asc';
                this.currentSortOrder = 'asc';
                this.nextSortOrder = 'desc';
              } else if (this.params.column.isSortDescending()) {
                this.sortStyleClassName='ag-header-cell-sorted-desc';
                this.currentSortOrder = 'desc';
                this.nextSortOrder = 'asc';
              } else {
                this.sortStyleClassName='ag-header-cell-sorted-none';
                this.nextSortOrder = 'asc';
                this.currentSortOrder = '';
              }
        }
    }
}
